import { css } from 'glamor';
import typography from '../../utils/typography';

const ribbon = css({
  width: '100%',
  display: 'flex',
  height: typography.rhythm(2),
});

export { ribbon };



// WEBPACK FOOTER //
// ./src/components/Ribbon/styles.js